import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'

import { useStyles } from '../styles'
import TableAA from '../../Tables/TableAA'
import TableAAPP from '../../Tables/TableAAPP'

const StreetMarketCard = (props) => {
  const {
    total = [],
    selectedDate,
    totalSegment = [],
    gTotal,
    gScooterA,
    gScooterB,
  } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Mercado STREET</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA array={total} selectedDate={selectedDate} disableAA />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución STREET en miles</h3>
            <br />
            <Bar
              id="1"
              redraw
              data={Utils.simpleBarLine(
                gTotal,
                'Y',
                'CANT',
                'VARIACION',
                'Año',
              )}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TableAAPP
              array={totalSegment}
              param="SEGMENTO"
              selectedDate={selectedDate}
              title="SUBSEGMENTO"
              AA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución STREET por segmento año</h3>
            <br />
            <Bar
              id="2"
              data={Utils.barLineDataGroup(gScooterA, 'y')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución STREET por segmento mes</h3>
            <br />
            <Bar
              id="3"
              data={Utils.barLineDataGroup(gScooterB, 'MES')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default StreetMarketCard
